export default "__VITE_ASSET__C2zcFBFy__"